// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8CGJq","right":"styles_right__1Pemf"};